import { render, staticRenderFns } from "./transition.vue?vue&type=template&id=45e5388a&"
import script from "./transition.vue?vue&type=script&lang=js&"
export * from "./transition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports